(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["racer-tabs"] && !Shopify.designMode) return;
  try {
    class RacerProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (this.tabs.length === 0) return;

      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      });

      this.addEventListener('keydown', (event) => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;

        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = current === last ? 0 : current + 1;
        if (event.key === 'ArrowLeft') next = current === 0 ? last : current - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        if (next !== null) {
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');

        const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !selected;
      });
    }
  }

  if (!customElements.get('racer-ptabs')) {
    customElements.define('racer-ptabs', RacerProductTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
